export default "__VITE_ASSET__E4U879cU__"